import MembersGroupsPicker from './MembersGroupsPicker.component';

export default MembersGroupsPicker;
